import { Stack, Box, Text } from '@chakra-ui/react';
import React from 'react';

interface PlanItemProps {
  title: string;
  cover: React.ReactElement;
  breakdown: React.ReactElement;
  footer: React.ReactElement;
}

const PlanItem: React.FC<PlanItemProps> = ({ cover, breakdown, footer, title }) => {
  return (
    <Stack direction={['column', 'column', 'row']} justify="center" spacing="12">
      <Box bg="white" position="relative" pt="65px" w="350px">
        <Box
          bg="white"
          h="10px"
          position="absolute"
          sx={{ transformOrigin: '100% 0', transform: 'skewY(-1deg)' }}
          top="-7.5px"
          w="100%"
        />
        <Box
          bg="blue.500"
          fontSize="lg"
          fontWeight="semibold"
          left="0"
          position="absolute"
          px="4"
          py="1"
          top="20px"
        >
          <Text color="white">{title}</Text>
        </Box>
        <Box mb="4" px="8">
          {cover}
        </Box>
        <Box
          bg="blue.100"
          h="10px"
          position="absolute"
          sx={{ transformOrigin: '0 0', transform: 'skewY(-1deg)' }}
          w="100%"
        />
        <Box bg="blue.100" px="8" py="4">
          <Box h="200px">{breakdown}</Box>
          <Box mb="4" mt="8">
            {footer}
          </Box>
        </Box>
        <Box
          bg="blue.500"
          h="10px"
          position="absolute"
          sx={{ transformOrigin: '0 0', transform: 'skewY(-1deg)' }}
          w="100%"
        />
      </Box>
    </Stack>
  );
};

export default PlanItem;
